import select2 from 'select2';

export function init() {
  $(`[data-select2-init]`).each((i, el) => {
    $(el).select2();
  })
}